<template>
  <div>
    <button class="ai-btn" @click="onAiButtonClick">AI助手</button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    onAiButtonClick() {
      this.$router.push({
        name: "AiView",
      });
    },
  },
};
</script>

<style scoped>
.ai-btn {
  width: 6%;
  position: fixed;
  bottom: 80px;
  right: 0px;
  background-color: #05a8ae;
  color: white;
  border: none;
  border-radius: 20px 0 0 20px;
  padding: 10px 15px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

.ai-btn:hover {
  background-color: #0056b3;
}
</style>
